import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AssetsFilterComponent } from './components/scripts/assetsFilter.component';
import { AssetsComponent } from './components/scripts/assets.component';
import { AssetsService } from '../shared/services/assets.service';

import { AssetsRoutingModule } from './assets-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AssetsRoutingModule
  ],
  declarations: [
    AssetsFilterComponent,
    AssetsComponent
  ],
  providers: [AssetsService]
})

export class AssetsModule { }



// WEBPACK FOOTER //
// ./src/app/assets/assets.module.ts